var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.conatiner
  }, [_vm.payoutSums.length > 0 ? _vm._l(_vm.progress, function (value, idx) {
    return _c('div', {
      key: idx,
      class: [_vm.$style.progress, _vm.computedClasses],
      style: Object.assign({
        width: "".concat(value, "%")
      }, _vm.getAnimationDelayVariables())
    });
  }) : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }